module.exports = __webpack_public_path__ + "img/7.6b2f08f1.png";